<template>
  <div class="row justify-content-center">
    <!-- loader -->
    <div id="loader" style="display: none">
<!--      <img src="assets/img/loading-icon.png" alt="icon" class="loading-icon">-->
    </div>
    <!-- * loader -->

    <!-- App Header -->
    <div class="appHeader no-border transparent position-absolute">
      <div class="left">
        <a href="#" class="headerButton goBack">
<!--          <ion-icon name="chevron-back-outline"></ion-icon>-->
        </a>
      </div>
      <div class="pageTitle"></div>
      <div class="right">
      </div>
    </div>
    <!-- * App Header -->

    <!-- App Capsule -->
    <div id="appCapsule" class="col-md-6 col-lg-4 col-xl-4">

      <div class="section mt-2 text-center">
        <img src="../assets/img/brand-logo.svg" width="220px" class="mb-4 mt-4"/>
      </div>
      <div class="section mb-5 p-2">

        <form action="index.html">
          <div class="card">
            <div class="card-body pb-1">
              <div class="form-group basic">
                <div class="input-wrapper">
                  <label class="label" for="name">Name</label>
                  <input v-model="name" type="name" class="form-control" id="name" :class="{ error: v$.name.$errors.length }" placeholder="Enter Your Name">
                  <i class="clear-input">
<!--                    <ion-icon name="close-circle"></ion-icon>-->
                  </i>
                  <div class="input-errors small text-danger justify-content-start d-flex" v-for="error of v$.name.$errors" :key="error.$uid">
                    <div class="error-msg">{{ error.$message }}</div>
                  </div>

                  <label class="label mt-4" for="name">Date of Birth</label>                  
                    <!-- <b-datepicker v-model="form[data.id]" :show-decade-nav="true" v-if="data.name === 'Date of Birth'" :max="max"></b-datepicker> -->
                     <date-picker
                      v-model="dob"
                      :config="config"
                      required
                      placeholder="Enter Your DOB"
                      ></date-picker>

                      <div class="input-errors small text-danger justify-content-start d-flex" v-for="error of v$.dob.$errors" :key="error.$uid">
                        <div class="error-msg">{{ error.$message }}</div>
                      </div>

                </div>
              </div>

              <div class="transparent mb-2 mt-2">
                <button type="submit" class="btn btn-primary btn-block btn-lg" @click.prevent="submitPhone" :disabled="!name"><b-spinner v-if="isWaitingResponse"></b-spinner><span v-else>Continue</span></button>
              </div>
            </div>
            
          </div>
          <!-- Important Instructions Section -->
          <div class="info-banner">
            <div class="info-banner__header">
              <span class="info-banner__icon-wrap">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="info-banner__icon">
                  <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd"/>
                </svg>
              </span>
              <div class="info-banner__title-block">
                <p class="info-banner__title-ml">ശ്രദ്ധിക്കേണ്ട നിർദേശങ്ങൾ / Important Instructions</p>
              </div>
            </div>

            <div class="info-banner__body">
              <!-- Login Section -->
              <div class="info-step">
                <div class="info-step__label">
                  <span class="info-step__num">1</span>
                  <p class="info-step__heading">ലോഗിൻ ചെയ്യുന്നതിന് <span class="info-step__heading-sep">/</span> Login Process</p>
                </div>
                <ul class="info-step__list">
                  <li>
                    <span class="info-step__bullet">&#10003;</span>
                    <span class="info-step__content">
                      <span class="info-step__line">ഇൻഷുറൻസ് രേഖകളിൽ നൽകിയിട്ടുള്ള അതേ പേരും ജനനത്തീയതിയും ഉപയോഗിച്ച് ലോഗിൻ ചെയ്യുക.</span>
                      <span class="info-step__line">Log in using the exact name and date of birth registered with your insurance.</span>
                    </span>
                  </li>
                  <li>
                    <span class="info-step__bullet info-step__bullet--warn">!</span>
                    <span class="info-step__content">
                      <span class="info-step__line">പേരിന്റെ ഇനിഷ്യൽ, അക്ഷരങ്ങൾക്കിടയിലുള്ള സ്പേസ് എന്നിവ ഇൻഷുറൻസ് പോളിസിയിൽ ഉള്ളതുപോലെ കൃത്യമായി രേഖപ്പെടുത്തേണ്ടതാണ്.</span>
                      <span class="info-step__line">Ensure initials and spacing match your insurance records precisely.</span>
                    </span>
                  </li>
                </ul>
              </div>

              <div class="info-divider"></div>

              <!-- Update Section -->
              <div class="info-step">
                <div class="info-step__label">
                  <span class="info-step__num">2</span>
                  <p class="info-step__heading">വിവരങ്ങൾ തിരുത്തുന്നതിന് <span class="info-step__heading-sep">/</span> Updating Details</p>
                </div>
                <ul class="info-step__list">
                  <li>
                    <span class="info-step__bullet">&#10003;</span>
                    <span class="info-step__content">
                      <span class="info-step__line">ലോഗിൻ ചെയ്ത ശേഷം, ആധാർ കാർഡിലെ വിവരങ്ങൾക്ക് അനുസൃതമായി പേരും ജനനത്തീയതിയും നൽകി ആവശ്യമായ മാറ്റങ്ങൾ വരുത്താവുന്നതാണ്.</span>
                      <span class="info-step__line">After logging in, update your details by entering your name and date of birth as per your Aadhaar card.</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- * Important Instructions Section -->

          
<!--          <div class="form-links mt-2">
            <div>
              <router-link to="/member-registration">Register as New Member</router-link>
            </div>
          </div>-->



        </form>
      </div>

    </div>
    <!-- * App Capsule -->
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import datePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import useNotyf from "../composable/useNotify";
export default {
  name: 'Login',
  data() {
    return {
      name: '',
      dob: '',
      isWaitingResponse: false,
      config: {
          format: 'DD-MM-YYYY',
          minDate: this.moment().subtract(80, 'years'),
          maxDate: this.moment(),
          date: null,
      },
    }
  },
  mounted() {
    console.log(process.env)
    localStorage.setItem('LoggedUser', false)
  },
  validations () {
    return {
      name: {
        required,
      },
      dob: {
        required
      }
    }
  },
  components: {
    datePicker
  },
  methods: {
    submitPhone() {
      this.v$.$validate()
      if(this.v$.$error) return
      this.isWaitingResponse = true
      this.$axios.post('employee-login', {
        name: this.name,
        dob: this.dob,
        prospect_ids: JSON.parse(process.env.VUE_APP_PROSPECT_ID),
        enrollment_validity: process.env.VUE_APP_ENROLLMENT_VALIDITY,
        confirmation_email_template_id: process.env.VUE_APP_CONFIRMATION_EMAIL_TEMPLATE_ID,
        employee_prospect_id: process.env.VUE_APP_EMPLOYEE_PROSPECT_ID
        // client_name: process.env.VUE_APP_CLIENT_NAME,
        // sms_otp_template_id: process.env.VUE_APP_SMS_TEMPLATE_ID
      }).then(({data}) => {
        this.isWaitingResponse = false
         if(data.status === 1 && !data.data.enrollment_url) {
          useNotyf().error('The entered details are not available in the system.')
        } else {
          localStorage.setItem('LoggedUser', false)
          window.location.href = data.data.enrollment_url
        }
        // if(data.status === 1) {
        //   this.$router.push({
        //     path: '/otp-verification',
        //     query: {
        //       phone: this.phone
        //     }
        //   })
        // }
      })
    }
  },
  setup: () => {
    return { v$: useVuelidate() }
  },
}
</script>

<style scoped>

/* ===== Info Banner ===== */
.info-banner {
  margin-top: 14px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 3px 14px rgba(128, 0, 0, 0.12), 0 1px 4px rgba(0,0,0,0.06);
  border: 1.5px solid rgba(128, 0, 0, 0.25);
  background: #fff8f8;
  text-align: left;
}

.info-banner__header {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #800000;
  padding: 10px 14px;
  text-align: left;
}

.info-banner__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.18);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.info-banner__icon {
  width: 18px;
  height: 18px;
  color: #fff;
}

.info-banner__title-block {
  display: flex;
  flex-direction: column;
}

.info-banner__title-ml {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  line-height: 1.5;
  letter-spacing: 0.1px;
}

.info-banner__body {
  padding: 14px 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
  text-align: left;
}

/* ===== Step ===== */
.info-step {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}

.info-step__label {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  text-align: left;
}

.info-step__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #800000;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
  margin-top: 2px;
  box-shadow: 0 2px 5px rgba(128, 0, 0, 0.3);
}

.info-step__heading {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #800000;
  line-height: 1.5;
  text-align: left;
}

.info-step__heading-sep {
  color: rgba(128,0,0,0.4);
  font-weight: 400;
  margin: 0 3px;
}

.info-step__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-left: 31px;
  text-align: left;
}

.info-step__list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  text-align: left;
}

.info-step__bullet {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(128, 0, 0, 0.08);
  color: #800000;
  font-size: 10px;
  font-weight: 900;
  flex-shrink: 0;
  margin-top: 2px;
  border: 1.5px solid rgba(128, 0, 0, 0.25);
}

.info-step__bullet--warn {
  background: rgba(128, 0, 0, 0.13);
  color: #800000;
  border-color: rgba(128, 0, 0, 0.4);
  font-size: 11px;
}

.info-step__content {
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
}

.info-step__line {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #2c0000;
  line-height: 1.6;
  text-align: left;
}

.info-step__line:nth-child(2) {
  color: #5a0000;
  font-weight: 500;
}

.info-divider {
  height: 1px;
  background: linear-gradient(90deg, rgba(128,0,0,0.08), rgba(128,0,0,0.3) 40%, rgba(128,0,0,0.3) 60%, rgba(128,0,0,0.08));
  margin: 12px 0;
}

</style>
